import { skipControllingPersonScreening, skipControllingPersonResult } from "../../../shared-helpers/src/controllingPersonScreening";
import { beneficialOwnerPercentage, isScreenableBeneficialOwner } from "../../../shared-helpers/src/beneficialOwners";
import type { CompanyRegistryBeneficiary } from "../types";
import React, { useContext, useMemo, useState } from "react";

import "dayjs/locale/en-gb";
import {
    Group,
    Modal,
    Text,
    Button,
    Table,
    Collapse,
    Space,
    Badge,
    Menu,
    Title,
    Stack,
    TextInput,
    Loader

} from "@mantine/core";

import {

    IconChevronDown, IconChevronUp,
    IconShare
} from "@tabler/icons-react";
import {
    IconEye,
} from "@tabler/icons-react";
import { openConfirmModal } from "@mantine/modals";
import { AMLScreeningHits, BaseResult, ContractPoliticalPosition, ControllingPerson, KYC, LegacyPoliticalPosition, NapierHitsClassification, PoliticalPosition, RelatedPartyAMLScreening, RelatedPartyScreeningRelation, UserDataType, onDemandAMLScreeningResponse } from "../types";
import { httpsCallable } from "firebase/functions";
import { useFunctions } from "../helpers/firebaseContext";
import { useForm } from "@mantine/form";
import { MyUserDataContext } from "../contexts";
import PepModificationModal from "./PepModificationModal";

//import { pdf } from '@react-pdf/renderer';
//import { ScreeningReportPDF } from './screening_report_pdf';


const RELATION_LABELS: Record<RelatedPartyScreeningRelation, string> = {
    authorized_signatory: "Authorized signatory",
    board_director: "Board director",
    executive_manager: "Executive manager",
    beneficial_owner: "Ultimate beneficial owner",
    guardian: "Guardian",
    minor: "Minor",
};

/**
 * One screening block: the status line, the hits modal and the review actions.  Rendered for the
 * customer's own screening and once per related party (authorized signatory / guardian / minor);
 * reviews of a related party's hits are routed with `relatedCustomerID`.
 */
function ScreeningSection({ kycData, customerID, label, screening, relatedParty }: {
    kycData: KYC
    customerID: string
    label: string
    screening?: onDemandAMLScreeningResponse
    relatedParty?: RelatedPartyAMLScreening
}) {
    const aml_screening = screening;
    const [screeningHits, setScreeningHits] = useState<AMLScreeningHits[]>([]);
    const userData: UserDataType = useContext(MyUserDataContext);
    const [modalOpen, setModalOpen] = useState(false)
    //const [loadingExportPDF, setLoadingExportPDF] = useState(false)
    const [napierScreeningOtherModal, setNapierScreeningOtherModal] = useState<AMLScreeningHits>();
    const [napierScreeningPepModal, setNapierScreeningPepModal] = useState<AMLScreeningHits>();

    const [expandedRow, setExpandedRow] = useState<number | null>(null);
    const toggleRow = (index: number) => {
        setExpandedRow((prev) => (prev === index ? null : index));
    };
    const functions = useFunctions();
    functions.region = "europe-west1";
    const screeningReview = httpsCallable<{
        kycID: string,
        hitId: string,
        token: string,
        review?: string,
        pepPoliticalPositions?: string[],
        relativePoliticalPositions?: string[],
        relativePoliticalPositionInformation?: { relation: string, name: string }[],
        customerID: string
        status: NapierHitsClassification,
        relatedCustomerID?: string,
    }, BaseResult>(functions, "screeningReview");

    // const handleExportPDF = async () => {
    //     setLoadingExportPDF(true);

    //     const blob = await pdf(
    //         <ScreeningReportPDF hits={screeningHits} screeningPayload={screeningPayload || {}} />
    //     ).toBlob();

    //     const url = URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = `Napier_Screening_Report_${(screeningPayload?.["Customer Name"] ?? '') + Date.now()}.pdf`; // custom file name
    //     link.click();
    //     URL.revokeObjectURL(url);

    //     setLoadingExportPDF(false);
    // };



    const renderAmlScreening = (label: string,) => {


        if (relatedParty?.status === 'failed') {
            return (
                <Group justify="space-between" wrap="nowrap" style={{ width: '100%' }}>
                    <Text fw={500} size="sm" ta="right">
                        {label}
                    </Text>
                    <Text size="xs" c="red" title={relatedParty.error}>
                        Screening failed{relatedParty.error ? `: ${relatedParty.error}` : ''}
                    </Text>
                </Group>
            );
        }

        if (!aml_screening || Object.keys(aml_screening)?.length === 0) {
            return (
                <Group justify="space-between" wrap="nowrap" style={{ width: '100%' }}>
                    <Text tt={relatedParty ? undefined : "capitalize"} fw={500} size="sm" ta="right">
                        {label}
                    </Text>
                    <Text size="xs" c="red">
                        Data does not exist
                    </Text>
                </Group>
            );
        }




        const totalHits = aml_screening?.hitsTotal;

        return (
            <Group justify="space-between" wrap="nowrap" style={{ width: '100%' }}>
                {/* Screening label */}
                <Text tt={relatedParty ? undefined : "capitalize"} fw={500} size="sm" ta="right">
                    {label}
                </Text>
                <Group gap="xs" align="center">

                    {/* Screening status */}
                    <Text size="xs" c={totalHits === 0 ? 'green' : 'red'}>
                        {totalHits === 0 ? 'No Screening Hits found' : `Screening Hits found (${totalHits})`}
                    </Text>

                    {/* Screening View table if hits */}
                    {totalHits !== 0 && (
                        <Group>

                            <Button
                                size="xs"
                                variant="light"
                                color="blue"
                                leftSection={<IconEye size={14} />}
                                onClick={() => {
                                    console.log("HITS=======>", aml_screening);
                                    setScreeningHits(aml_screening?.screeningHitsOpt || []);
                                    setModalOpen(true);
                                }}
                            >
                                View
                            </Button>


                        </Group>
                    )}
                </Group>
            </Group>
        );
    };
    const form = useForm();



    const renderHitsTable = useMemo(() => {


        console.log("aml_screening =======>", aml_screening)

        return <Table striped highlightOnHover withTableBorder>

            <Table.Thead>
                <Table.Tr>
                    <Table.Th>#</Table.Th>
                    <Table.Th>Name</Table.Th>
                    <Table.Th>Original Script Name</Table.Th>
                    <Table.Th>Best Match</Table.Th>
                    <Table.Th>Primary Name</Table.Th>
                    <Table.Th>Total Score</Table.Th>
                    <Table.Th>Details</Table.Th>
                    <Table.Th>Napier Details</Table.Th>
                    <Table.Th>Review</Table.Th>
                </Table.Tr>
            </Table.Thead>
            {/* Screening View table >> Tbody */}
            <Table.Tbody>

                {aml_screening?.screeningHitsOpt?.map((hit, index) => {
                    const ref = hit?.policyRecommendation || {};
                    const isOpen = expandedRow === index;
                    const refSplitURL = hit.refDataId.split(":");
                    return (
                        <React.Fragment key={index}>
                            <Table.Tr>
                                <Table.Td>{index + 1}</Table.Td>
                                {/* Screening View table >> Tbody >> Input Data: Customer Name*/}
                                <Table.Td>{aml_screening?.input?.p["customerName"] ?? '-'}</Table.Td>
                                <Table.Td>{aml_screening?.input?.p["originalScriptName"] ?? '-'}</Table.Td>
                                {/* Screening View table >> Tbody >> Result Data >> screen >> screeningHitsOpt >> matchedName*/}
                                <Table.Td>{hit?.matchedName || '-'}</Table.Td>
                                {/* Screening View table >> Tbody >> Result Data >> screen >> screeningHitsOpt >> refPrimaryName*/}
                                <Table.Td>{hit?.refPrimaryName || '-'}</Table.Td>
                                {/* Screening View table >> Tbody >> Result Data >> screen >> screeningHitsOpt >> policyRecommendation >> totalScore */}
                                <Table.Td>{ref?.totalScore?.toLocaleString() || '-'}</Table.Td>
                                {/* Screening View table >> Tbody >> Result Data >> screen >> screeningHitsOpt >> policyRecommendation >> score */}
                                {/* <Table.Td>{ref?.score?.toFixed(2) || '-'}</Table.Td> */}
                                <Table.Td>
                                    <Button
                                        size="xs"
                                        variant="light"
                                        color='blue'
                                        onClick={() => toggleRow(index)}
                                        leftSection={isOpen ? <IconChevronUp size={14} /> : <IconChevronDown size={14} />}
                                    >
                                        {isOpen ? 'Hide' : 'More'}
                                    </Button>
                                </Table.Td>

                                <Table.Td>
                                    {refSplitURL?.length > 2 ? <Button
                                        size="xs"
                                        variant="light"
                                        color="blue"
                                        component="a"
                                        target="_blank"
                                        href={`${import.meta.env.VITE_NAPIER_API_BASE_URL}reference-data/${refSplitURL[0]}:${refSplitURL[1]}/${hit.entityType?.toLowerCase()}/${refSplitURL[2]}`}
                                        leftSection={<IconShare size={14} />}

                                    >
                                        View on Napier
                                    </Button> : "----"}

                                </Table.Td>

                                <Table.Td>

                                    {hit.napierReview ?


                                        <Group >

                                            <Badge variant="dot">
                                                {hit?.napierReview?.review_code}
                                            </Badge>
                                        </Group>

                                        : <Group style={{ width: "100%" }} justify="end" >
                                            <Button
                                                size="xs"
                                                color='green'
                                                onClick={() => openConfirmModal({
                                                    title: 'Confirm False positive Napier findings',
                                                    children: <Text c="red">
                                                        Napier has identified hits on this customer, make sure you have carefully reviewed the customer and correctly identified the hits as "false positive"

                                                    </Text>,
                                                    labels: { confirm: "confirm", cancel: "cancel" },
                                                    confirmProps: { bg: "green" },
                                                    onConfirm: async () => {

                                                        const token = await userData.getAzureADToken!(userData);
                                                        if (!token) {
                                                            throw new Error("No Microsoft Token. Try refreshing.");
                                                        }
                                                        await screeningReview({
                                                            relatedCustomerID: relatedParty?.customerID,
                                                            customerID: customerID,
                                                            kycID: kycData?.id!,
                                                            hitId: hit.refDataId,
                                                            token: token,
                                                            status: NapierHitsClassification.false_positive,

                                                        })
                                                    }
                                                })}
                                            >
                                                False positive
                                            </Button>

                                            <Menu shadow="md" width={200}>
                                                <Menu.Target>
                                                    <Button>True Match</Button>
                                                </Menu.Target>

                                                <Menu.Dropdown>

                                                    <Menu.Item
                                                        variant="outline"
                                                        color="orange"
                                                        onClick={() => relatedParty
                                                            ? openConfirmModal({
                                                                title: 'Confirm PEP Napier findings on related party',
                                                                children: <Text c="red">
                                                                    This confirms that {relatedParty.name_en || 'the related party'} ({RELATION_LABELS[relatedParty.relation]}) has been identified as a PEP.
                                                                    The KYC owner's own political positions are not changed by this review.
                                                                </Text>,
                                                                labels: { confirm: "confirm", cancel: "cancel" },
                                                                confirmProps: { bg: "orange" },
                                                                onConfirm: async () => {
                                                                    const token = await userData.getAzureADToken!(userData);
                                                                    if (!token) {
                                                                        throw new Error("No Microsoft Token. Try refreshing.");
                                                                    }
                                                                    await screeningReview({
                                                                        relatedCustomerID: relatedParty.customerID,
                                                                        customerID: customerID!,
                                                                        kycID: kycData?.id!,
                                                                        hitId: hit.refDataId,
                                                                        token,
                                                                        status: NapierHitsClassification.true_match_pep,
                                                                        review: "AML screening result",
                                                                    })
                                                                }
                                                            })
                                                            : setNapierScreeningPepModal(hit)}
                                                    >
                                                        True Match - PEP
                                                    </Menu.Item>

                                                    <Menu.Divider />
                                                    <Menu.Item
                                                        variant="outline"
                                                        color="red"
                                                        onClick={() => openConfirmModal({
                                                            title: 'Confirm Sanctions Napier findings',
                                                            children: <Text c="red">
                                                                This will REJECT the customer's KYC automatically, this action cannot be reversed.
                                                            </Text>,
                                                            labels: { confirm: "confirm", cancel: "cancel" },
                                                            confirmProps: { bg: "orange" },
                                                            onConfirm: async () => {

                                                                const token = await userData.getAzureADToken!(userData);
                                                                if (!token) {
                                                                    throw new Error("No Microsoft Token. Try refreshing.");
                                                                }
                                                                await screeningReview({
                                                            relatedCustomerID: relatedParty?.customerID,
                                                                    token,
                                                                    customerID: customerID!,
                                                                    kycID: kycData?.id!,
                                                                    hitId: hit.refDataId,
                                                                    status: NapierHitsClassification.true_match_sanctions,

                                                                })
                                                            }

                                                        })}
                                                    >
                                                        True Match - Sanctions
                                                    </Menu.Item>
                                                    <Menu.Divider />
                                                    <Menu.Item
                                                        variant="outline"
                                                        color="purple"
                                                        onClick={() => setNapierScreeningOtherModal(hit)}
                                                    >
                                                        True Match - (Other)
                                                    </Menu.Item>



                                                </Menu.Dropdown>
                                            </Menu>

                                            {/* <Button
                                            size="xs"
                                            color='red'
                                            onClick={() => openConfirmModal({
                                                title: 'Confirm PEP Napier findings',
                                                children: <Text c="red">
                                                    Napier has identified hits on this customer, this confirms that there is a match and that this person has been identified as PEP.
                                                    this will override the customer's risk level to high.
                                                </Text>,
                                                labels: { confirm: "confirm", cancel: "cancel" },
                                                confirmProps: { bg: "red" },
                                                onConfirm: async () => await screeningReview({
                                                            relatedCustomerID: relatedParty?.customerID,
                                                    customerID: customerID!,
                                                    kycID: kycData?.id!,
                                                    hitId: hit.refDataId,
                                                    status: NapierHitsClassification.true_match_sanctions,

                                                }),

                                            })}
                                        >
                                            True Match - Sanctions
                                        </Button> */}
                                        </Group>}
                                </Table.Td>

                            </Table.Tr>

                            <Table.Tr>
                                <Table.Td colSpan={7} style={{ padding: 0, border: 'none' }}>
                                    <Collapse expanded={isOpen}>
                                        <div style={{ padding: '10px 15px', backgroundColor: '#f9f9f9' }}>
                                            <Text size="xs" fw={500}>Ref Watchlist Categories:</Text>
                                            {/* Screening View table >> Tbody >> Result Data >> screen >> screeningHitsOpt >> refWatchlistCategories */}
                                            <Text size="xs" mb={6}>
                                                {(hit?.refWatchlistCategories || []).join(', ') || '-'}
                                            </Text>

                                            <Text size="xs" fw={500}>Country Info:</Text>
                                            {/* Screening View table >> Tbody >> Result Data >> screen >> screeningHitsOpt >> refDetails >> refCountryInformation */}
                                            <Text size="xs">
                                                {hit?.refDetails?.refCountryInformation || '-'}
                                            </Text>
                                        </div>
                                    </Collapse>
                                </Table.Td>
                            </Table.Tr>
                        </React.Fragment>
                    );
                })}
            </Table.Tbody>
        </Table>
    }

        , [screeningHits, aml_screening, expandedRow])
    return (
        <>
            <Group mt={relatedParty ? 4 : "sm"} gap="xs" style={{ width: '100%' }}>
                {renderAmlScreening(label)}
            </Group>

            <Modal
                opened={modalOpen}
                onClose={() => {
                    setModalOpen(false);
                    setExpandedRow(null); // ← Reset on close
                }}
                title={`Screening Hits — ${label}`}
                size="auto"
                // size="xl"
                centered
            >
                {screeningHits?.length === 0 ? (
                    <Text>No hits available.</Text>
                ) : (
                    <>
                        {/* Export PDF Button as of now hide*/}
                        {/* <Button
                            size="xs"
                            color="blue"
                            loading={loadingExportPDF}
                            style={{ marginBottom: 12 }}
                            onClick={handleExportPDF}
                        >
                            Export to PDF
                        </Button> */}

                        <PepModificationModal
                            requireEditReason={false}
                            politicalPositionOptions={Object.values(PoliticalPosition).map((position) => ({ value: position, label: position }))}
                            initialPepPoliticalPositions={(kycData?.politicalPosition || []) as string[]}
                            initialRelativePoliticalPositions={(kycData?.relativePoliticalPosition || []) as string[]}
                            initialRelativePoliticalPositionInformation={kycData?.relativePoliticalPositionInformation || []}
                            opened={!!napierScreeningPepModal}
                            onClose={() => {
                                setNapierScreeningPepModal(undefined);
                            }}
                            onSubmit={async (values: any) => {
                                const token = await userData.getAzureADToken!(userData);
                                if (!token) {
                                    throw new Error("No Microsoft Token. Try refreshing.");
                                }

                                const response = await screeningReview({
                                                            relatedCustomerID: relatedParty?.customerID,
                                    customerID: customerID!,
                                    kycID: kycData?.id!,
                                    hitId: napierScreeningPepModal!.refDataId,
                                    token,
                                    status: NapierHitsClassification.true_match_pep,
                                    review: "AML screening result",
                                    pepPoliticalPositions: values.includePep ? values.pepPoliticalPositions : [],
                                    relativePoliticalPositions: values.includeRelative ? values.relativePoliticalPositions : [],
                                    relativePoliticalPositionInformation: values.includeRelative ? [{ relation: values.relativeRelation, name: values.relativeName }] : [],
                                });
                                return response;

                            }}
                        />
                        <Modal
                            opened={!!napierScreeningOtherModal}
                            onClose={() => {
                                form.reset();
                                setNapierScreeningOtherModal(undefined);

                            }}
                            title={<Title order={3}>Napier Hits - Other</Title>}
                        >
                            <form
                                onSubmit={form.onSubmit(async (values) => {


                                    try {

                                        const token = await userData.getAzureADToken!(userData);
                                        if (!token) {
                                            throw new Error("No Microsoft Token. Try refreshing.");
                                        }
                                        const response = await screeningReview({
                                                            relatedCustomerID: relatedParty?.customerID,
                                            customerID: customerID!,
                                            kycID: kycData?.id!,
                                            review: values.review,
                                            token: token,
                                            hitId: napierScreeningOtherModal!.refDataId,
                                            status: NapierHitsClassification.true_match_other,

                                        })
                                        if (response.data.status === "success") {

                                            setNapierScreeningOtherModal(undefined);
                                        }
                                    } catch (error: any) {

                                    }

                                })}
                            >
                                <Stack>


                                    <>
                                        <Text>Enter the reason for this classification</Text>
                                        <TextInput
                                            {...form.getInputProps("review")}
                                        />
                                    </>


                                    <Group>

                                        <Button
                                            color={"orange"}
                                            type="submit"

                                        >
                                            Confirm - True Match (Other)
                                        </Button>

                                    </Group>


                                </Stack>
                            </form>
                        </Modal>
                        {(aml_screening && !!Object.keys(aml_screening)?.length) ? renderHitsTable : <Loader />}
                    </>
                )}
            </Modal >
            {!relatedParty && <Space h="md" />}
            {/* {renderAmlActions} */}
            {/* <Space h="sm" /> */}
        </>
    );
}

/** Reuse the same submission-scoped result and review routing inside the controlling-person card. */
export function ControllingPersonScreening({ kycData, customerID, relatedCustomerID, name, controllingPerson, originalSubmittedAt, originalSubmissionLoading, originalSubmissionError }: {
    kycData?: KYC; customerID: string; relatedCustomerID?: string; name: string; controllingPerson?: ControllingPerson; originalSubmittedAt?: Date; originalSubmissionLoading?: boolean; originalSubmissionError?: boolean;
}) {
    if (controllingPerson && (originalSubmissionLoading || originalSubmissionError)) {
        return <Text size="sm" c="dimmed">{name}: {originalSubmissionError ? 'Could not verify original submission date' : 'Checking original submission date'}</Text>;
    }
    if (skipControllingPersonScreening(kycData, controllingPerson, originalSubmittedAt)) {
        return <Text size="sm" c="dimmed">{name}: Skipped — submitted before 25 Oct 2026, 12:00 Kuwait; Civil ID missing</Text>;
    }
    const party = relatedCustomerID ? kycData?.aml_screening_related?.[relatedCustomerID] : undefined;
    if (!kycData || !party || kycData.aml_screening_status === 'pending' || kycData.aml_screening_status === 'running') {
        return <Text size="sm" c="dimmed">{name}: {kycData?.aml_screening_status === 'running' ? 'Screening in progress' : 'Not screened for this KYC'}</Text>;
    }
    return <ScreeningSection kycData={kycData} customerID={customerID} label={name}
        screening={party.aml_screening} relatedParty={party} />;
}

const RELATION_ORDER: RelatedPartyScreeningRelation[] = ["authorized_signatory", "board_director", "executive_manager", "beneficial_owner", "guardian", "minor"];

export function BeneficialOwnerScreening({ kycData, customerID, owner }: { kycData?: KYC; customerID: string; owner: CompanyRegistryBeneficiary }) {
    const name = owner.name_en || owner.name || owner.civil_id || 'Beneficial owner';
    const percentage = beneficialOwnerPercentage(owner.ownership_percentage);
    if (!isScreenableBeneficialOwner(owner)) {
        return <Text size="sm" c="dimmed">{name}: {percentage === undefined ? 'Invalid ownership percentage' : 'Below 25% ownership — excluded from UBO screening'}</Text>;
    }
    return <ControllingPersonScreening kycData={kycData} customerID={customerID} relatedCustomerID={owner.customerID}
        name={`${name} (${percentage}% ownership)`} />;
}

/**
 * AML screening panel of a KYC: the customer's own Napier result followed by the related parties
 * screened alongside it (company signatories or a minor's guardian; also displays historical results).
 */
export function NapierAmlScreeningView({ kycData, customerID, originalSubmittedAt }: {

    kycData: KYC
    customerID: string
    originalSubmittedAt?: Date
}) {
    // Approval checks these submission results independently of each party's own KYC.
    const relatedParties = Object.values(kycData.aml_screening_related ?? {})
        .filter(party => !skipControllingPersonResult(kycData, party, originalSubmittedAt)).sort((a, b) =>
        RELATION_ORDER.indexOf(a.relation) - RELATION_ORDER.indexOf(b.relation)
        || (a.name_en || '').localeCompare(b.name_en || ''));

    return (
        <>
            <ScreeningSection
                kycData={kycData}
                customerID={customerID}
                label="AML Screening"
                screening={kycData.aml_screening}
            />
            {relatedParties.length > 0 && (
                <Stack gap={2}>
                    <Text size="xs" c="dimmed" fw={500}>Related parties screened with this KYC</Text>
                    {relatedParties.map((party) => (
                        <ScreeningSection
                            key={party.customerID}
                            kycData={kycData}
                            customerID={customerID}
                            label={`${party.name_en || party.crmID || party.customerID} (${RELATION_LABELS[party.relation]})`}
                            screening={party.aml_screening}
                            relatedParty={party}
                        />
                    ))}
                    <Space h="md" />
                </Stack>
            )}
        </>
    );
}
